/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed } from '@/tools/money';

import { payStatusRender } from '@/page/settlementCenter/utils';

export { projectPriceHanderl } from '@/page/settlementCenter/common/tableConfig/fields';

export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  orderNo: {
    label: '订单编号',
    prop: 'payOrderNo'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  finishSumTaskPrice: {
    label: '终端结算总金额',
    prop: 'projectPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  monthTaskPrice: {
    label: '项目当期收入',
    prop: 'projectPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  tax: {
    label: '增值税率',
    prop: 'vatRate'
    // formatter(r, c, v) {
    //   return (v / 100).toFixed(2) + '%';
    // }
  },
  commission2: {
    label: '供应商服务费率',
    prop: 'supplierServiceRate'
    // formatter(r, c, v) {
    //   return (v / 100).toFixed(2) + '%';
    // }
  },
  commission: {
    label: '商务服务费率',
    prop: 'commission',
    formatter(r, c, v) {
      return (v / 100).toFixed(2) + '%';
    }
  },
  totalPrice: {
    label: '商务服务费',
    prop: 'platformServices',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    render: (h, ctx, r) => {
      return (
        <div>
          <span>{payStatusRender(r, null)}</span>
        </div>
      );
    }
  }
};
